<!-- This component shows the location finder section if a product is only available offline
     By default the location finder section is hidden, If a location is changed by the user or on page
     load if the product is determined to be available only offline in that state the section is displayed
-->

<script>
import $dom from 'cash-dom';
import productCTAButtonsMixin from '../../mixins/productCTAButtonsMixin';

export default {
  components: {},
  mixins: [productCTAButtonsMixin],
  props: {
    product: {
      type: Object,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    metafields: {
      type: Object,
      required: true
    }
  },
  computed: {
    findInStoreProduct() {
      return (
        this.content !== null && this.canFindInStore && !this.canAddProduct
      );
    }
  },
  mounted() {
    this.updateLocationFinder();
  },
  methods: {
    updateLocationFinder() {
      if (this.findInStoreProduct) {
        $dom('#location-finder-wrapper').css('display', 'block');
      } else {
        $dom('#location-finder-wrapper').css('display', 'none');
      }
    },
    afterLocationUpdate() {
      this.updateLocationFinder();
    }
  }
};
</script>
